<template>
  <div class="modal fade" :id="id" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
      <form @submit.prevent="saveBudget" class="form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('budgets.label.dispatchByStep') }}</h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="closeModal">
                <span class="svg-icon svg-icon-1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                          fill="currentColor" />
                    <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                          fill="currentColor" />
                  </svg>
                </span>
            </div>
          </div>

          <div class="modal-body">   
            <RequiredText :text="$t('budgets.cantBeChanged')"/>
            <Card class="bg-primary p-5 mb-5">
              <div class="fs-1 text-center text-white">{{$t("budgets.name")}}</div>
              <div class="text-white text-center display-5 fw-bold">{{formattedLocalAmount(formData.forecast_budget) }} {{ iso }}</div>
            </Card>

            <div class="table-responsive">
              <table class="table table-row-bordered">
                <thead>
                  <tr class="fw-bold fs-3">
                    <th>{{ $t('projects.label.step') }}</th>
                    <th>{{ $t('budgets.label.allocated_budget') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="step in formData?.steps" :key="step?.id">
                    <td><span class="fs-4 badge badge-light fw-bolder me-auto px-4 py-3">{{ step.project_category_step_name }}</span></td>
                    <td>
                      <VueNumberFormat v-model:value="step.forecast_budget" class="form-control form-control-solid" :options="{ precision: 0, prefix: '', acceptNegative: false, isInteger: false  }"
                      ></VueNumberFormat>
                    </td>
                  </tr>
                </tbody>
              </table>
              </div>
          </div>
          <div class="modal-footer">
            <Button type="cancel" @click="closeModal" :id="id+'_cancel_btn'" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel"></Button>
            <Button btn-class="btn-sm me-3" type="submit" :id="id+'_submit_btn'" btn-text="button.save" size="7px 30px" :is-loading="isSaving"></Button>
          </div>
        </div>
      </form>
    </div>
  </div>

</template>
<script setup>

import {ref, defineProps, watch, defineEmits} from 'vue'
import {useStore} from "vuex";
import Button from "@/components/Button.vue"
import Input from "@/components/Input";
import RequiredText from "@/components/RequiredText";
import VueNumberFormat from 'vue-number-format'
import SwitchInput from '@/components/SwitchInput.vue';
import { useRoute } from 'vue-router';
import Select2 from '@/components/Select2.vue';
import { computed } from 'vue';
import Card from '@/components/Card.vue';
import { formattedLocalAmount } from '@/mixins/Helpers';

const emits = defineEmits(['load'])

const props = defineProps({
    id: {
      type: String,
      required: true
    },
    iso: {
      type: String,
      required: false
    },
    form: {
      type: Object,
      default: {
        id: '',
        budget_name: '',
        forecast_budget: 0,
        currency_id: "",
        steps: []
      }
    },
}) 

const store = useStore()
const route = useRoute()

const formData = ref(props.form)
const isSaving = ref(false)

watch(() => props.form, () => {
  formData.value = props.form
})

function closeModal(){
  $('#'+props.id).modal('toggle')
}

function saveBudget(){
  isSaving.value = true
  const data = {
    ...formData.value,
    id: route.params.id,
    steps: formData.value?.steps?.map(el => ({
      project_category_step_id: el?.project_category_step_id,
      forecast_budget: el?.forecast_budget
    }))
  }
  store.dispatch('projects/saveProjectBudget', data)
      .then((response) => {
          isSaving.value = false
          emits('load')
          closeModal()
          
          window.toastr['success'](i18n.global.t('notification.budget_dispatched_successfully'))
      })
      .catch(err => {
          isSaving.value = false
      })
}
</script>